import { gql } from "graphql-request";
import { z } from "zod";
import { NewsEntryArticleSchema } from "./newsEntryArticle";

import { Image, ImageFragment } from "../image";
import { SysFragment } from "../sys";
import {
  TextBlockFragment,
  ImageBlockFragment,
  FeatureBlockFragment,
  VideoBlockFragment,
  EmbeddedVideoBlockFragment,
  PollBlockFragment,
  LeaderboardBlockFragment,
  ProgressTrackerBlockFragment,
} from "./blocks";
import { UnifiedButtonFragment } from "../unifiedButton";
import { CarouselEventProgressTrackerEntryFragment } from "./carouselEventProgressTrackerEntry";

export const SmallNewsEntryArticleSchema = NewsEntryArticleSchema.extend({
  __typename: z.literal("SmallNewsEntryArticle"),
  smallThumbnail: Image.nullable(),
  smallThumbnailEn: Image.nullable(),
}).omit({
  largeThumbnail: true,
  largeThumbnailEn: true,
});

export const SmallNewsEntryArticle = SmallNewsEntryArticleSchema;
export type SmallNewsEntryArticle = z.infer<typeof SmallNewsEntryArticleSchema>;

export const SmallNewsEntryArticleFragment = gql`
  fragment SmallNewsEntryArticleFragment on SmallNewsEntryArticle {
    sys {
      ...SysFragment
    }
    title
    blogSlug
    whereToPublish
    showInNewsFeed
    showInWebsiteNewsFeed
    heroImage {
      ...ImageFragment
    }
    heroImageEn: heroImage(locale: "en") {
      ...ImageFragment
    }

    heroProgressTracker {
      ...CarouselEventProgressTrackerEntryFragment
    }

    websiteHeroImage {
      ...ImageFragment
    }
    websiteHeroImageEn: websiteHeroImage(locale: "en") {
      ...ImageFragment
    }

    smallThumbnail {
      ...ImageFragment
    }
    smallThumbnailEn: smallThumbnail(locale: "en") {
      ...ImageFragment
    }

    bodyCollection(limit: 70) {
      items {
        __typename
        ... on FeatureBlock {
          ...FeatureBlockFragment
        }
        ... on ImageBlock {
          ...ImageBlockFragment
        }
        ... on TextBlock {
          ...TextBlockFragment
        }
        ... on VideoBlock {
          ...VideoBlockFragment
        }
        ... on EmbeddedVideoBlock {
          ...EmbeddedVideoBlockFragment
        }
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
        ... on PollBlock {
          ...PollBlockFragment
        }
        ... on LeaderboardBlock {
          ...LeaderboardBlockFragment
        }
        ... on ProgressTrackerBlock {
          ...ProgressTrackerBlockFragment
        }
      }
    }
  }

  ${ImageFragment}
  ${SysFragment}
  ${TextBlockFragment}
  ${ImageBlockFragment}
  ${FeatureBlockFragment}
  ${VideoBlockFragment}
  ${EmbeddedVideoBlockFragment}
  ${PollBlockFragment}
  ${UnifiedButtonFragment}
  ${LeaderboardBlockFragment}
  ${ProgressTrackerBlockFragment}
  ${CarouselEventProgressTrackerEntryFragment}
`;
